export const unixTimestapFormatter = (value: number) => {
  if (value) {
    // Time as a unix timestamp
    return (new Date(value * 1000))
      .toLocaleString(
        navigator.language,
        { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' },
      );
  } else {
    return '';
  }
};
